import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  MediaGateway,
  MediaGatewayMenuActionsType,
} from 'data/mediaGateway/mediaGateway.types';
import './media-gateway-action-menu.scss';

type Props = {
  selectedItem?: MediaGateway;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const MediaGatewayMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="MediaGatewayMenu" className="media-gateway-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="media-gateway-action-menu-button"
        data-testid={`${MediaGatewayMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="media-gateway-action-menu-button"
        data-testid={`${MediaGatewayMenuActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('mediaGateway.deletePopup.title')}
        displayMessage={
          t('collectionFunction.deletePopup.message', { name: selectedItem.name })
        }
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default MediaGatewayMenu;
